<template>

  <div class="vflex">
    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>{{ 'Software Engineer' }}</h4>
          <h6>Criado em 2024-07-19</h6>
        </div>
      </div>
    </div>

    <div class="vflex-row-1">
      <JobRhevolut />
    </div>

  </div>

</template>

<script>
import JobRhevolut from '@/components/Job/JobRhevolut/JobRhevolut'

export default {
  name: 'Bucket',
  components: {
    JobRhevolut
  },
  data () {
    return {
      creating: false,
      loading: false,
      modal_select: false,
      filters: {},
      sort: 'name',
      selected: [],
      modelType: 'candidate'
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    loadData () {

    },
    /*
    modal
    */
    showCreateModal () {
      this.modal_select = {
        type: this.modelType
      }
    },
    showEditModal (item) {
      this.modal_select = item
    },
    hideModal () {
      this.modal_select = false
    },
    /*
    filters
    */
    setKeywords (keywords) {
      this.filters = keywords ? {name: '~' + keywords} : {}
      this.loadData(1)
    },
    setSort (sort) {
      this.sort = sort
      this.loadData(1)
    },
    changeModelType (type) {
      this.creating = true
      this.modelType = type
      this.loadData()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/RhevolutJobList/RhevolutJobView.vue